import { useEffect, useState } from 'react'
import QR from 'qrcode'
import { FileFormats, FileSizes } from '.'

type QRCodeOptions = QR.QRCodeToDataURLOptions | QR.QRCodeToStringOptions

export const useQRCodeDownload = (url: string) => {
  const [downloadUrl, setDownloadUrl] = useState(url)
  const [downloadWidth, setDownloadWidth] = useState<FileSizes>(200)
  const [downloadFormat, setDownloadFormat] = useState<FileFormats>(
    'image/jpeg'
  )

  useEffect(() => {
    const downloadOptions: QRCodeOptions = {
      margin: 0,
      width: downloadWidth,
      type: downloadFormat,
    }

    if (downloadFormat === 'svg') {
      QR.toString(
        url,
        downloadOptions as QR.QRCodeToStringOptions,
        (error, svgString) => {
          if (error) return console.error(error)

          const svgBlob = new Blob([svgString], {
            type: 'image/svg+sml;charset=utf-8',
          })
          const svgUrl = URL.createObjectURL(svgBlob)

          setDownloadUrl(svgUrl)
        }
      )
    } else {
      QR.toDataURL(
        url,
        downloadOptions as QR.QRCodeToDataURLOptions,
        (error, imgUrl) => {
          if (error) return console.error(error)

          setDownloadUrl(imgUrl)
        }
      )
    }
  }, [url, downloadWidth, downloadFormat])

  return [
    downloadUrl,
    setDownloadWidth,
    downloadFormat,
    setDownloadFormat,
  ] as const
}
